import * as React from 'react';
import { Brand, Group, Site } from '../../../../client-management/entities';
import { defaultUser, IUser } from '../data/NewUserConstants';
import { IValue as ImportedValue, NewUserProvider } from './newUserProvider';
import { ActionTypes, newUserReducer } from './newUserReducer';
import { Role } from '../../../entities';

export type IValue = ImportedValue;

export interface IAction {
  type: ActionTypes;
  payload?: any;
}

export type Dispatch = (action: IAction) => void;

export interface IState {
  user: IUser;
  roles: Role[];
  stepValid: boolean;
  validSteps: number[];
  groups: Group[];
  brands: Brand[];
  sites: Site[];
  createdUser?: IUser;
  success?: boolean;
  error?: boolean;
  errorMessage?: string;
}

export const defaultContextValues: IState = {
  stepValid: false,
  validSteps: [],
  user: defaultUser,
  roles: [],
  groups: [],
  brands: [],
  sites: [],
  success: false,
};

export const NewUserStateContext = React.createContext<IState | undefined>(undefined);
export const NewUserDispatchContext = React.createContext<Dispatch | undefined>(undefined);

function useNewUserState() {
  const context = React.useContext(NewUserStateContext);
  if (context === undefined) {
    throw new Error('useNewUserState must be used within a NewUserProvider');
  }
  return context;
}

function useNewUserDispatch() {
  const context = React.useContext(NewUserDispatchContext);
  if (context === undefined) {
    throw new Error('useNewUserDispatch must be used within a NewUserProvider');
  }
  return context;
}

export { NewUserProvider, newUserReducer, useNewUserState, useNewUserDispatch };
